import { Paper, PaperProps, styled } from "@mui/material";

export const AssistantPaper = styled(Paper)(() => ({
  display: "flex",
  height: "100%",
  zIndex: "auto",
})) as React.ComponentType<PaperProps>;
